import { fetcher } from "@website/fetcher/fetcher";
import {
  ResetPasswordVerifyOtpBodyType,
  ResetPasswordVerifyOtpResponseType
} from "@website/widget/login/services/reset-password-verify-otp/reset-password-verify-otp.types";

export const ResetPasswordVerifyOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/reset-password/verify-otp`;

export const ResetPasswordVerifyOtpService = (
  body: ResetPasswordVerifyOtpBodyType
): Promise<ResetPasswordVerifyOtpResponseType> =>
  fetcher({
    url: ResetPasswordVerifyOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
